'use client';

import React, { createContext, useEffect, useMemo, useState } from 'react';

import { TenantDetailsResponse } from 'utils/GeneratedApi';

type TenantContextType = React.Context<{
  tenant?: TenantDetailsResponse;
  setTenant: (tenant: TenantDetailsResponse) => void;
}>;

const TenantContext: TenantContextType = createContext({
  setTenant: (tenant) => {
    console.log('Tenant info from context', tenant);
  },
});

const TenantProvider = ({
  tenantData,
  children,
}: {
  tenantData: TenantDetailsResponse;
  children: React.ReactNode;
}) => {
  const [tenant, setTenant] = useState(tenantData);
  const value = useMemo(() => ({ tenant, setTenant }), [tenant]);

  useEffect(() => {
    if (tenantData) {
      setTenant(tenantData);
    }
  }, [tenantData]);

  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
};

export { TenantContext, TenantProvider };
